import React from 'react';

export interface TypingIndicatorProps {
  visible: boolean;
  className?: string;
}

/**
 * Animated "ESA is thinking" indicator shown while a converse response streams.
 * Uses the ESA accent token so it stays visible on the light panel surface
 * (the shared foundation Loader paints white-on-primary bars that disappear here).
 */
export function TypingIndicator({ visible, className }: TypingIndicatorProps): React.ReactElement | null {
  if (!visible) return null;
  return (
    <div
      className={`flex items-center gap-1.5 px-4 py-3 ${className ?? ''}`}
      aria-live="polite"
      aria-label="ESA is thinking"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-esa-accent animate-bounce [animation-delay:-0.3s]" />
      <span className="w-1.5 h-1.5 rounded-full bg-esa-accent animate-bounce [animation-delay:-0.15s]" />
      <span className="w-1.5 h-1.5 rounded-full bg-esa-accent animate-bounce" />
    </div>
  );
}
